import React from "react";

import { CATEGORY_TOTAL, CATEGORY_1 } from "../../../constants";

export default function ContractSummaryInfoItem({ category, group, groupClass, contractHolderCount, contractCount }) {
  return (
    <tr role="row" data-type={group}>
      <th id={`${category}-${group}-${groupClass}`} role="rowheader" headers="group">
        {group === "Total" && category !== CATEGORY_TOTAL
          ? category === CATEGORY_1
            ? "Total Category 1 (Group A)"
            : "Total Category 2 (Groups B-D)"
          : group + (groupClass === null ? "" : ` - ${groupClass}`)}
      </th>
      <td className="text-center" role="gridcell" headers={`${group} ch`}>
        {contractHolderCount}
      </td>
      <td className="text-center" role="gridcell" headers={`${group} contract`}>
        {contractCount}
      </td>
    </tr>
  );
}
